import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";

const DrugChartList = ({ items = [], onView, className, onTake }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Drug chart has been added yet</strong>
            </div>
        );
    return (
        <div className={`${className}`}>
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{ width: "10%" }} className="text-center">
                            SN
                        </th>
                        <th style={{ width: "35%" }}>Drugs</th>
                        <th style={{ width: "20%" }} className="text-center">
                            Status
                        </th>
                        <th style={{ width: "25%" }}>Staff</th>
                        <th style={{ width: "20%" }} className="text-center">
                            View
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="text-center">
                                <strong>{index + 1}</strong>
                            </td>
                            <td onClick={() => onView(item)}>
                                {item.prescriptions.length > 1 ? (
                                    <>
                                        {item.prescriptions[0].drugName} <span className="badge badge-success">and {item.prescriptions.length - 1} more</span>
                                    </>
                                ) : (
                                    <>
                                        <strong>{item.prescriptions[0].drugName}</strong>
                                        <br />
                                        {item.prescriptions[0].dose}
                                    </>
                                )}

                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                                <br />
                            </td>
                            <td className="text-center">{item.active ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Passed</span>}</td>
                            <td>
                                <StaffProfileCard item={item.author} />
                            </td>
                            <td className="view-message text-center">
                                <button onClick={() => onView(item)} title="View Detail" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                    <i className="material-icons text-primary">trending_flat</i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DrugChartList;
